import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface RecentSearch {
  id: string
  label: string
  href: string
  at: number
}

interface RecentSearchState {
  items: RecentSearch[]
  add: (item: Omit<RecentSearch, 'id' | 'at'>) => void
  clear: () => void
}

export const useRecentSearchStore = create<RecentSearchState>()(
  persist(
    (set, get) => ({
      items: [],
      add: (item) => {
        const entry: RecentSearch = {
          ...item,
          id: crypto.randomUUID(),
          at: Date.now(),
        }
        const filtered = get().items.filter((i) => i.href !== item.href)
        set({ items: [entry, ...filtered].slice(0, 6) })
      },
      clear: () => set({ items: [] }),
    }),
    { name: 'qbc-recent-searches' },
  ),
)
